import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initNewsSlider = () => {
  const sliderEl = document.querySelector(".news__slider");
  if (!sliderEl) return;

  const sectionEl = sliderEl.closest(".news");
  const slides = Array.from(sliderEl.querySelectorAll(".news__slide"));
  const total = slides.length;
  const prevEl = sectionEl?.querySelector(".news__btn--prev");
  const nextEl = sectionEl?.querySelector(".news__btn--next");
  const progressFillEl = sectionEl?.querySelector(".news__progress-fill");
  const counterEl = sectionEl?.querySelector(".news__counter");

  const updateProgress = (activeIndex = 0) => {
    const progress = total > 0 ? ((activeIndex + 1) / total) * 100 : 0;
    const current = String(activeIndex + 1).padStart(2, "0");

    progressFillEl?.style.setProperty("--news-progress", `${progress}%`);

    if (counterEl) {
      counterEl.textContent = `/${current}`;
    }
  };

  const swiper = new Swiper(sliderEl, {
    modules: [Keyboard, Mousewheel, Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2.7,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    on: {
      init(instance) {
        updateProgress(instance.realIndex);
      },
      slideChange(instance) {
        updateProgress(instance.realIndex);
      },
    },
  });

  updateProgress(swiper.realIndex);
};

export default initNewsSlider;
